import { getBaseURL } from '@/environments'
import url from '../api/urls'

const state = () => ({
  baseURL: getBaseURL(),
  configs: [],
  isLoading: false,
  isMobile: window.matchMedia('(max-width: 767px)').matches
})

const getters = {
  isMobile: (state) => state.isMobile,
  baseURL (state) {
    return state.baseURL
  },
  configMap (state) {
    const configMap = new Map()
    state.configs.forEach((config) => {
      if (config.startDateTime && config.endDateTime) {
        const currentDateTime = new Date()
        const startDateTime = new Date(config.startDateTime)
        const endDateTime = new Date(config.endDateTime)
        config.isDisplay =
          config.isDisplay &&
          currentDateTime >= startDateTime &&
          currentDateTime <= endDateTime
      }
      configMap.set(config.key, config)
    })
    return configMap
  }
}

const actions = {
  async getConfigs ({ commit }) {
    commit('startLoading')
    try {
      const response = await fetch(url.config, {
        method: 'GET',
        headers: {
          Accept: 'application/json'
        }
      })
      const data = await response.json()
      commit('setConfigs', [...data])
      commit('stopLoading')
    } catch (error) {
      commit('stopLoading')
      console.error('Error fetching configurations:', error)
      throw error // Propagate the error to the component
    }
  }
}

const mutations = {
  startLoading (state) {
    state.isLoading = true
  },
  stopLoading (state) {
    state.isLoading = false
  },
  setConfigs (state, configs) {
    state.configs = configs
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
